:host {
  display: block;
}

::slotted(*:not(:first-of-type)) {
  @apply border-x-0 border-y-0 border-t border-solid border-grey-lighter md:mt-0 md:border-0;
}
